const angular = require('angular')
const readService = require('./readService')
const readCtrl = require('./readCtrl')
const readContentCtrl = require('./readContentCtrl')
const recallResultType = require('./recallResultType')
require('./readDirectives')

module.exports = angular.module('hxphone.read', ['hxphone.mail', 'hxphone.readDirectives'])
  .service('readService', readService)
  .service('recallResultType', recallResultType)
  .controller('readCtrl', readCtrl)
  .controller('readContentCtrl', readContentCtrl)



// WEBPACK FOOTER //
// ./src/js/mail/read/module.js